import React from "react";
import { useNavigate } from "react-router-dom";
import { OrderDbType } from "../../models/order_model";
import { formatNumber } from "../../middleware/common-functions";
import Button from "../../components/buttons";

interface PaymentSuccessProps {
  order: OrderDbType & { doc_id: string };
}

const PaymentSuccess: React.FC<PaymentSuccessProps> = ({ order }) => {
  const history = useNavigate();

  const handlePrint = () => {
    window.print();
  };

  const handleViewOrder = () => {
    history(`/cuenta/orden/${order.doc_id}`);
  };

  return (
    <div className="payment-success p-4">
      <div className="text-center mb-4">
        <i
          className="fas fa-check-circle text-success"
          style={{ fontSize: "4rem" }}
        ></i>
        <h2 className="mt-3">¡Pago Exitoso!</h2>
        <p className="text-muted">Tu orden ha sido procesada correctamente</p>
      </div>

      <div className="order-summary mb-4">
        <h4>Resumen de la Orden</h4>
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between mb-2">
              <span>Número de Orden:</span>
              <span className="fw-bold">{order.doc_id}</span>
            </div>
            <div className="d-flex justify-content-between mb-2">
              <span>Total:</span>
              <span className="fw-bold">
                ${formatNumber(order.totals.total)}
              </span>
            </div>
            {order.mp_payment && (
              <div className="d-flex justify-content-between mb-2">
                <span>Tarjeta:</span>
                <span className="fw-bold">
                  **** **** **** {order.mp_payment.card}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="d-flex flex-column flex-md-row justify-content-center gap-3">
        <Button
          onClick={handlePrint}
          children="Imprimir Comprobante"
          width="200px"
          icon="print"
          title="Imprimir"
          buttonclasses="gray"
        />
        <Button
          onClick={handleViewOrder}
          children="Ver Orden"
          width="200px"
          icon="eye"
          title="Ver Orden"
          buttonclasses="dark"
        />
      </div>
    </div>
  );
};

export default PaymentSuccess;
